// Curated starter library. Uses Unsplash Source for placeholder imagery.
// Admin's uploads + gradients get merged with these.

const seedBackgrounds = [
  // --- Nature ---
  {
    id: 'seed-mountain-dawn',
    name: 'Mountain Dawn',
    tags: ['nature'],
    type: 'image',
    src: 'https://images.unsplash.com/photo-1506905925346-21bda4d32df4?w=2400&q=80',
    thumb: 'https://images.unsplash.com/photo-1506905925346-21bda4d32df4?w=400&q=60',
    priority: 30,
    schedule: { kind: 'library' },
    settings: { blur: 0, dim: 30, parallax: 100, overlayColor: '#0a0a0a', overlayAlpha: 0, scale: 110 },
  },
  {
    id: 'seed-forest-mist',
    name: 'Forest Mist',
    tags: ['nature'],
    type: 'image',
    src: 'https://images.unsplash.com/photo-1441974231531-c6227db76b6e?w=2400&q=80',
    thumb: 'https://images.unsplash.com/photo-1441974231531-c6227db76b6e?w=400&q=60',
    priority: 30,
    schedule: { kind: 'library' },
    settings: { blur: 2, dim: 25, parallax: 100, overlayColor: '#0a0a0a', overlayAlpha: 0, scale: 110 },
  },
  {
    id: 'seed-ocean-calm',
    name: 'Ocean Calm',
    tags: ['nature'],
    type: 'image',
    src: 'https://images.unsplash.com/photo-1505142468610-359e7d316be0?w=2400&q=80',
    thumb: 'https://images.unsplash.com/photo-1505142468610-359e7d316be0?w=400&q=60',
    priority: 30,
    schedule: { kind: 'library' },
    settings: { blur: 0, dim: 35, parallax: 100, overlayColor: '#0a0a0a', overlayAlpha: 0, scale: 110 },
  },
  {
    id: 'seed-sky-pastel',
    name: 'Pastel Sky',
    tags: ['nature'],
    type: 'image',
    src: 'https://images.unsplash.com/photo-1519681393784-d120267933ba?w=2400&q=80',
    thumb: 'https://images.unsplash.com/photo-1519681393784-d120267933ba?w=400&q=60',
    priority: 30,
    schedule: { kind: 'library' },
    settings: { blur: 0, dim: 20, parallax: 100, overlayColor: '#fff7ed', overlayAlpha: 10, scale: 110 },
  },

  // --- Office / workspace ---
  {
    id: 'seed-office-desk',
    name: 'Bright Desk',
    tags: ['office'],
    type: 'image',
    src: 'https://images.unsplash.com/photo-1497366216548-37526070297c?w=2400&q=80',
    thumb: 'https://images.unsplash.com/photo-1497366216548-37526070297c?w=400&q=60',
    priority: 30,
    schedule: { kind: 'library' },
    settings: { blur: 6, dim: 40, parallax: 100, overlayColor: '#ffffff', overlayAlpha: 20, scale: 112 },
  },
  {
    id: 'seed-office-plants',
    name: 'Studio Plants',
    tags: ['office'],
    type: 'image',
    src: 'https://images.unsplash.com/photo-1524758631624-e2822e304c36?w=2400&q=80',
    thumb: 'https://images.unsplash.com/photo-1524758631624-e2822e304c36?w=400&q=60',
    priority: 30,
    schedule: { kind: 'library' },
    settings: { blur: 4, dim: 35, parallax: 100, overlayColor: '#ffffff', overlayAlpha: 15, scale: 110 },
  },
  {
    id: 'seed-office-warm',
    name: 'Warm Co-Working',
    tags: ['office'],
    type: 'image',
    src: 'https://images.unsplash.com/photo-1497215842964-222b430dc094?w=2400&q=80',
    thumb: 'https://images.unsplash.com/photo-1497215842964-222b430dc094?w=400&q=60',
    priority: 30,
    schedule: { kind: 'library' },
    settings: { blur: 6, dim: 40, parallax: 100, overlayColor: '#fff7ed', overlayAlpha: 20, scale: 110 },
  },

  // --- Seasonal / holidays (scheduled yearly) ---
  {
    id: 'seed-holiday-christmas',
    name: 'Christmas Lights',
    tags: ['seasonal'],
    type: 'image',
    src: 'https://images.unsplash.com/photo-1512389142860-9c449e58a543?w=2400&q=80',
    thumb: 'https://images.unsplash.com/photo-1512389142860-9c449e58a543?w=400&q=60',
    priority: 80,
    schedule: { kind: 'yearly', start: '12-20', end: '12-26' },
    settings: { blur: 0, dim: 45, parallax: 100, overlayColor: '#0a0a0a', overlayAlpha: 10, scale: 110 },
  },
  {
    id: 'seed-holiday-newyear',
    name: 'New Year Fireworks',
    tags: ['seasonal'],
    type: 'image',
    src: 'https://images.unsplash.com/photo-1546271876-af6caec5fae4?w=2400&q=80',
    thumb: 'https://images.unsplash.com/photo-1546271876-af6caec5fae4?w=400&q=60',
    priority: 80,
    schedule: { kind: 'yearly', start: '12-31', end: '01-02' },
    settings: { blur: 0, dim: 40, parallax: 100, overlayColor: '#0a0a0a', overlayAlpha: 10, scale: 110 },
  },
  {
    id: 'seed-holiday-autumn',
    name: 'Autumn Leaves',
    tags: ['seasonal'],
    type: 'image',
    src: 'https://images.unsplash.com/photo-1507371341162-763b5e419408?w=2400&q=80',
    thumb: 'https://images.unsplash.com/photo-1507371341162-763b5e419408?w=400&q=60',
    priority: 60,
    schedule: { kind: 'yearly', start: '10-15', end: '11-20' },
    settings: { blur: 0, dim: 30, parallax: 100, overlayColor: '#0a0a0a', overlayAlpha: 0, scale: 110 },
  },

  // --- Time-of-day ---
  {
    id: 'seed-tod-morning',
    name: 'Golden Morning',
    tags: ['nature'],
    type: 'image',
    src: 'https://images.unsplash.com/photo-1495197359483-d092478c170a?w=2400&q=80',
    thumb: 'https://images.unsplash.com/photo-1495197359483-d092478c170a?w=400&q=60',
    priority: 50,
    schedule: { kind: 'timeOfDay', timeStart: '06:00', timeEnd: '11:00' },
    settings: { blur: 0, dim: 30, parallax: 100, overlayColor: '#fff7ed', overlayAlpha: 10, scale: 110 },
  },
  {
    id: 'seed-tod-evening',
    name: 'Quiet Dusk',
    tags: ['nature'],
    type: 'image',
    src: 'https://images.unsplash.com/photo-1472552944129-b035e9ea3744?w=2400&q=80',
    thumb: 'https://images.unsplash.com/photo-1472552944129-b035e9ea3744?w=400&q=60',
    priority: 50,
    schedule: { kind: 'timeOfDay', timeStart: '17:30', timeEnd: '22:00' },
    settings: { blur: 0, dim: 45, parallax: 100, overlayColor: '#030213', overlayAlpha: 15, scale: 110 },
  },

];

export default seedBackgrounds;
